<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Frau Julie Schubert ins Stammbuch</h3>
<p class="vers">Ich kam vom Pflug der Erde<br class="calibre2"/>
zum Flug ins weite All<br class="calibre2"/>
und vom Gebrüll der Herde<br class="calibre2"/>
zum Sang der Nachtigall.</p>
<p class="vers">Die Welt hat manche Straße,<br class="calibre2"/>
und jede gilt mir gleich,<br class="calibre2"/>
ob ich ins Erdreich fasse,<br class="calibre2"/>
ob ins Gedankenreich.</p>
<p class="vers">Es wiegt mit gleicher Schwere<br class="calibre2"/>
auf Erden jedes Glied.<br class="calibre2"/>
Ihr gebt mir eure Ähre,<br class="calibre2"/>
ich gebe euch mein Lied.</p>
<p class="centersml">1880</p>
<p class="calibre1"><a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page15" title="wedi/Konmax"></a> <a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page16" title="wedi/Konmax"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?e7c6b550